function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import { Util, PRIMERA_VENTANA_ID } from '../index';
import ContenidoVentana from './contenido-ventana';
import VisorImagenes from '../visor-imagenes/components/visor-imagenes';
import AreaImagen from '../visor-imagenes/components/area-imagen';
import AreaMiniaturas from '../visor-imagenes/components/area-miniaturas';
import BotoneraAreaImagenVisorDerecha from '../visor-imagenes/components/botonera-area-imagen-visor-derecha';
import BotoneraAreaImagenVisorIzquierda from '../visor-imagenes/components/botonera-area-imagen-visor-izquierda';
import ContenidosVisor from '../visor-imagenes/components/contenidos-visor';

var vinculoAbrirZona = function vinculoAbrirZona(libroId, numPagina, numPaso) {
  return {
    vinculo: 'funcion,abrirZona:' + libroId + Util.pad3(numPagina) + '.' + numPaso
  };
};

var getImageSrc = function getImageSrc(_ref) {
  var libroId = _ref.libroId,
      numHistoria = _ref.numHistoria,
      numPaso = _ref.numPaso;
  return 'contenido/' + libroId + Util.pad2(numHistoria) + Util.pad2(Number(numPaso)) + '.png';
};

var getImageSrcA = function getImageSrcA(_ref2) {
  var libroId = _ref2.libroId,
      numHistoria = _ref2.numHistoria,
      numPaso = _ref2.numPaso;
  return 'contenido/' + libroId + Util.pad2(numHistoria) + Util.pad2(Number(numPaso)) + 'a.png';
};

var ContenidoTipoHistoriaManual = function (_Component) {
  _inherits(ContenidoTipoHistoriaManual, _Component);

  function ContenidoTipoHistoriaManual(props) {
    _classCallCheck(this, ContenidoTipoHistoriaManual);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleBotonSiguiente = function () {
      var _this$props = _this.props,
          libroId = _this$props.libroId,
          numPagina = _this$props.numPagina,
          numPaso = _this$props.numPaso;
      var vinculo = vinculoAbrirZona(libroId, numPagina, Number(numPaso) + 1);

      _this.props.onBoton(vinculo, PRIMERA_VENTANA_ID);
    };

    _this.handleBotonAnterior = function () {
      var _this$props2 = _this.props,
          libroId = _this$props2.libroId,
          numPagina = _this$props2.numPagina,
          numPaso = _this$props2.numPaso;
      var vinculo = vinculoAbrirZona(libroId, numPagina, Number(numPaso) - 1);

      _this.props.onBoton(vinculo, PRIMERA_VENTANA_ID);
    };

    _this.handleBotonMiniatura = function (vinculo) {
      var onBoton = _this.props.onBoton;
      onBoton && onBoton(vinculo);
    };

    _this.handleBotonTexto = function () {
      _this.setState(function (prevState) {
        return {
          versionImagen: prevState.versionImagen === 'a' ? '' : 'a'
        };
      });
    };

    _this.state = {
      versionImagen: '',
      imageSrc: getImageSrc(props),
      imageSrcA: getImageSrcA(props)
    };
    return _this;
  }

  ContenidoTipoHistoriaManual.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.numPaso !== this.props.numPaso || prevProps.libroId !== this.props.libroId || prevProps.numHistoria !== this.props.numHistoria) {
      this.setState({
        imageSrc: getImageSrc(this.props),
        imageSrcA: getImageSrcA(this.props)
      }, this.handleLoad);
    }
  };

  ContenidoTipoHistoriaManual.prototype.crearVinetas = function crearVinetas() {
    var _props = this.props,
        numPasos = _props.numPasos,
        numHistoria = _props.numHistoria,
        numPagina = _props.numPagina,
        libroId = _props.libroId;
    var vinetas = [];

    for (var i = 0; i < numPasos; i++) {
      vinetas.push({
        src: 'contenido/' + libroId + Util.pad2(numHistoria) + Util.pad2(i + 1) + 'b.png',
        vinculo: vinculoAbrirZona(libroId, numPagina, i + 1)
      });
    }

    return vinetas;
  };

  ContenidoTipoHistoriaManual.prototype.render = function render() {
    var _props2 = this.props,
        numPaso = _props2.numPaso,
        numPasos = _props2.numPasos,
        hayBotonTexto = _props2.hayBotonTexto,
        txtNumVineta = _props2.txtNumVineta,
        children = _props2.children;
    var vinetas = this.crearVinetas();
    var paso = numPaso;
    var _state = this.state,
        imageSrc = _state.imageSrc,
        imageSrcA = _state.imageSrcA,
        versionImagen = _state.versionImagen;
    return React.createElement(ContenidoVentana, null, React.createElement(VisorImagenes, {
      clasesExtra: 'historia'
    }, React.createElement(AreaImagen, null, React.createElement(BotoneraAreaImagenVisorIzquierda, {
      paso: paso,
      onBotonAnteriorClick: this.handleBotonAnterior,
      txtNumVineta: txtNumVineta
    }), React.createElement(ContenidosVisor, {
      src: imageSrc,
      srcA: imageSrcA,
      versionImagen: versionImagen,
      paso: paso
    }, children), React.createElement(BotoneraAreaImagenVisorDerecha, {
      versionImagen: versionImagen,
      onBotonTextoClick: hayBotonTexto ? this.handleBotonTexto : false,
      paso: paso,
      numPasos: numPasos,
      onBotonSiguienteClick: this.handleBotonSiguiente
    })), React.createElement(AreaMiniaturas, {
      vinetas: vinetas,
      paso: Number(paso),
      onBoton: this.handleBotonMiniatura
    })));
  };

  return ContenidoTipoHistoriaManual;
}(Component);

ContenidoTipoHistoriaManual.propTypes = process.env.NODE_ENV !== "production" ? {
  hayBotonTexto: t.bool,
  libroId: t.string,
  numPagina: t.number,
  numHistoria: t.string,
  numPaso: t.string,
  numPasos: t.number,
  txtNumVineta: t.string,
  onBoton: t.func,
  children: t.any
} : {};
export default ContenidoTipoHistoriaManual;